import { lazy, Suspense, useEffect, useState } from "react";

// Los dos sistemas de avisos (toasts) no se ven en el primer pintado: se
// montan tras la hidratación para que su JS salga de la ruta crítica.
const Toaster = lazy(() =>
  import("@/components/ui/toaster").then((m) => ({ default: m.Toaster })),
);
const Sonner = lazy(() =>
  import("@/components/ui/sonner").then((m) => ({ default: m.Toaster })),
);

const DeferredToasters = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const activate = () => setReady(true);
    const events = ["pointerdown", "keydown"] as const;
    events.forEach((event) => window.addEventListener(event, activate, { once: true, passive: true }));
    return () => events.forEach((event) => window.removeEventListener(event, activate));
  }, []);

  if (!ready) return null;

  return (
    <Suspense fallback={null}>
      <Toaster />
      <Sonner />
    </Suspense>
  );
};

export default DeferredToasters;
